
<main>
    <div class="jobs">
        <h4>કાર્યક્રમ દાતાઓ યાદી</h4>
        <hr>
        <div class="filtering">
            <form>
                <input placeholder="શોધો..." type="search" #filter (keyup)="applyFilter($event)" class="form-control"
                    aria-label="Search box">
                <i class="ti ti-search"></i>
            </form>
        </div>
        <div>
            <div class="main-members">
                <a class="member-list-item" *ngFor="let data of getEventDonorList">
                    <div class="flex1">
                        <h5>{{data.member_name}}</h5>
                        <small>કાર્યક્રમ : {{data.sub_event_name}}</small><br>
                    </div>
                </a>
            </div>
        </div>
    </div>
</main>